export function textDirection(text) {
    const s= text  
     //const s= "Dostępne ankiety"
     let weakChars       = '\u0000-\u0040\u005B-\u0060\u007B-\u00BF\u00D7\u00F7\u02B9-\u02FF\u2000-\u2BFF\u2010-\u2029\u202C\u202F-\u2BFF',
      rtlChars        = '\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC',
      rtlDirCheck     = new RegExp('^['+weakChars+']*['+rtlChars+']');
    // return rtlDirCheck.test(s);
     if(rtlDirCheck.test(s)){
         return "rtl"
     }else{
         return "ltr"
     }
}